module.exports = __webpack_public_path__ + "8b91c6b8139e906b2a12b056d0356934.svg";